import { render } from "./AccountingHeader.vue?vue&type=template&id=6f2e8e10&scoped=true"
import script from "./AccountingHeader.vue?vue&type=script&lang=js"
export * from "./AccountingHeader.vue?vue&type=script&lang=js"

import "./AccountingHeader.vue?vue&type=style&index=0&id=6f2e8e10&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2e8e10"]])

export default __exports__